// @flow
import reducer from './duck/reducer';

export * from './duck';
export default reducer;
